import React from "react";

export function EmptyState({
    icon,
    title,
    description,
    action,
    className = "",
    testId,
}) {
    return (
        <div
            data-testid={testId || "empty-state"}
            className={`flex flex-col items-center justify-center text-center px-6 py-16 ${className}`}
        >
            {icon && (
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-md-surface-2 text-md-text-2">
                    {icon}
                </div>
            )}
            {title && (
                <h3 className="text-lg font-semibold tracking-tight text-md-text">{title}</h3>
            )}
            {description && (
                <p className="mt-2 max-w-sm text-sm leading-relaxed text-md-text-2">
                    {description}
                </p>
            )}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}

export default EmptyState;
